import { Checkbox, Slider } from 'antd'
import Flex from 'components/Flex'
import React from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

import InputNumber from 'components/Form/InputNumber'

export const MainWrapper = styled(Flex)`
  width: 100%;
  gap: 10px;
  overflow-y: hidden;
  background-color: #fafafb;
  ${props =>
    props.preventScroll &&
    css`
      overflow: hidden;
    `}
`

export const Container = styled(Flex)`
height : 75vh;
overflow-y: scroll;
  padding: 20px 25px 300px 25px;
  gap: 5%;
`
export const LeftDiv = styled.div`
  min-width: 20%;
`
export const LastDiv = styled.div`
  width: ${props => props.hidden ? '0%' : '30%'};
  padding-bottom: ${props => props.hidden ? '0' : '300px'};
  overflow: hidden;
  transition: width 0.2s ease;
`
export const RightDiv = styled.div`
  width: ${props => props.wide ? '75%' : '50%'};
  // height : 72vh;
  padding: 20px 5px 300px 5px;
  // overflow-x: hidden;
  // overflow-y: scroll;
  position: relative;
  transition: width 0.2s ease;
  &::-webkit-scrollbar {
    display: none;
  }
`
export const FormHeading = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
  margin-bottom: 20px;
`

export const StickyDiv = styled.div`
  position: fixed;
  top: 15rem;
`

export const StyledSlider = styled(Slider)`
  width: 95% !important;
  padding: 0px !important;
  height: 2px !important;
  margin: 10px 10px !important;
  margin-bottom: 30px !important;
  .ant-slider-handle {
    width: 20px;
    height: 20px;
    margin-top: -9px;
    background: ${COLORS.WHITE};
    border: 1px solid ${COLORS.GREY_T_95};
    box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  }
  .ant-slider-track {
    background-color: ${COLORS.PRIMARY} !important;
  }
  .ant-slider-rail,
  .ant-slider-track {
    height: 4px !important;
  }
  .ant-slider-dot {
    border: none !important;
  }
  .ant-slider-mark-text {
    transform: none !important ;
  }
`

export const StyledInput = styled(InputNumber)`
  padding-top: 0px !important;
  .ant-input-number-handler-wrap {
    display: none;
  }
`
const StyledStrong = styled.strong`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: ${COLORS.GREY_T_60};
`
export const Range = {
  [3]: {
    style: {
      marginTop: 'px',
    },
    label: <StyledStrong>{3}</StyledStrong>,
  },
  [12]: {
    style: {
      marginTop: '-6px',
    },
    label: <StyledStrong>{12}</StyledStrong>,
  },
}

export const FlexibleDiv = styled.div`
  display: flex;
`

export const SliderWidth = styled.div`
  width: 70%;
`
export const InputWidth = styled.div`
  width: 50px;
`
export const StyledInputWidth = styled.div`
  width: 70px;
  margin-left: 50px;
`

export const StyledGroup = styled(Checkbox.Group)`
  padding-top: 8px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  .ant-checkbox-wrapper {
    color: #343e59 !important;
  }
  font-weight: 600;
`
